module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/yuki-50484b8c74b4b6489c2fde1e9fdce937.webp";